// Norwegian nynorsk. Same keys as nb in ../i18n.ts (the type checks that).
import type { Key, Text } from '../i18n.ts';

export const nn: Record<Key, Text> = {
  appName: 'Finn tid',
  tagline: 'finn dagen som passar for flest',
  privacy: 'Personvern',
  sourceCode: 'Kjeldekode',
  heroTitle: 'Finn tida som passar for flest',
  heroLead: 'Lag ei avrøysting, vel moglege dagar eller klokkeslett og del lenkja. Alle markerer når dei kan – utan innlogging.',
  newEvent: 'Ny avrøysting',
  yourEvents: 'Avrøystingane dine',
  yourEventsHint: 'Blir berre hugsa på denne eininga. Lenkjene verkar på alle einingar.',
  showAllEvents: 'Vis alle ({n})',
  findLink: 'Finn avrøystingane dine frå ei anna eining',
  findTitle: 'Finn avrøystingane dine',
  findLead: 'Skriv e-postadressa du oppgav då du laga eller svarte på ei avrøysting. Vi sender ein kode til ho, og så blir avrøystingane lagde til på denne eininga.',
  findEmail: 'E-postadresse',
  findSend: 'Send kode',
  findSent: 'Er adressa brukt på ei avrøysting her, kjem det straks ein e-post med ein kode. Koden verkar i 10 minutt.',
  findCode: 'Kode frå e-posten',
  findShow: 'Vis avrøystingane mine',
  findLinkLead: 'Trykk på knappen for å leggje avrøystingane for e-postadressa di til på denne eininga. Lenkja verkar éin gong.',
  findAgain: 'Send ny kode',
  findOther: 'Bruk ei anna adresse',
  findAsked: 'Bad om ein ny kode.',
  findFound: { one: 'Fann {n} avrøysting. Ho er lagd til på denne eininga.', other: 'Fann {n} avrøystingar. Dei er lagde til på denne eininga.' },
  findNone: 'Fann ingen avrøystingar med denne adressa.',
  openAdmin: 'Admin',
  openMine: 'Svara mine',
  open: 'Opna',
  tagAdmin: 'Admin',
  tagAnswered: 'Svart',
  forget: 'Gløym på denne eininga',
  leave: 'Logg ut',
  leaveQ: 'Logge ut på denne eininga?',
  leaveTextAdmin: 'Admin-lenkja blir fjerna frå denne eininga, og avrøystinga forsvinn frå lista di her. For å kome tilbake treng du lenkja, så ta vare på henne først.',
  leaveTextMine: 'Den personlege lenkja di blir fjerna frå denne eininga, og avrøystinga forsvinn frå lista di her. For å endre svara seinare treng du lenkja, så ta vare på henne først.',
  leaveEmail: 'Du kan òg få lenkja tilbake med ein kode til e-postadressa di.',
  leftToast: 'Logga ut på denne eininga',
  step1: 'Vel moglege dagar',
  step1Text: 'Datoar, eller klokkeslett på kvar dag. Fjern helger og heilagdagar med eitt trykk.',
  step2: 'Del lenkja',
  step2Text: 'Éi lenkje til alle. Kvar deltakar får si eiga lenkje for å endre svara.',
  step3: 'Sjå kva som passar',
  step3Text: 'Dagane og tidene som passar for flest, kjem øvst.',
  loading: 'Lastar …',
  pageNotFound: 'Fann ikkje sida',
  toHome: 'Til framsida',
  eventNotFound: 'Fann ikkje avrøystinga',
  eventNotFoundText: 'Ho kan vere sletta, eller lenkja er feil. Avrøystingar blir sletta automatisk 30 dagar etter siste dato.',
  retry: 'Prøv igjen',
  reload: 'Last inn på nytt',
  newVersion: 'Ein ny versjon er klar.',
  changedMeanwhile: 'Nokon andre endra nett no avrøystinga.',
  back: 'Tilbake',
  cancel: 'Avbryt',
  ok: 'OK',
  done: 'Ferdig',
  save: 'Lagre',
  saved: 'Lagra',
  delete: 'Slett',
  deleted: 'Sletta',
  copy: 'Kopier',
  copied: 'Kopiert',
  share: 'Del',
  link: 'Lenkje',
  more: 'Meir',
  yes: 'Ja',
  maybe: 'Kanskje',
  no: 'Nei',
  name: 'Namn',
  sum: 'Kan',
  you: 'deg',
  language: 'Språk',

  editEvent: 'Endre avrøystinga',
  aboutEvent: 'Om avrøystinga',
  eventName: 'Namn på avrøystinga',
  eventNamePh: 'Til dømes «Julebord»',
  descriptionOptional: 'Skildring (valfritt)',
  locationOptional: 'Stad (valfritt)',
  whatToFind: 'Kva skal de finne?',
  'mode.dates': 'Dagar',
  'mode.datesHint': 'Kva dagar passar?',
  'mode.times': 'Klokkeslett',
  'mode.timesHint': 'Kva tider passar, dag for dag?',
  fromHour: 'Frå kl.',
  toHour: 'Til kl.',
  slotLength: 'Ruter på',
  meetingLength: 'Møtet varer',
  timeZone: 'Tidssone',
  timeZoneHint: 'Alle ser tidene i denne tidssona.',
  possibleDays: 'Moglege dagar',
  theme: 'Tema',
  'theme.auto': 'Automatisk',
  'theme.autoHint': 'Lys eller mørk, som eininga',
  'theme.light': 'Lys',
  'theme.dark': 'Mørk',
  'theme.hacker': 'Hacker',
  rangeHint: 'Dra frå ein dag til ein annan for å ta med alle dagane mellom, eller klikk den første og shift-klikk den siste.',
  rangeHintTouch: 'Hald fingeren på ein dag og dra til ein annan for å ta med alle dagane mellom.',
  possibleDaysHint: 'Trykk på dagane som kan passe, eller vel fleire med knappane. Knappane endrar berre utvalet – du kan framleis leggje til eller fjerne enkeltdagar etterpå.',
  period2w: 'Neste 2 veker',
  period4w: 'Neste 4 veker',
  periodMonth: 'Heile {month}',
  periodHint: 'Vel akkurat desse dagane (i staden for dei du har valt)',
  moreMonths: 'Vis neste månad',
  selNone: 'Ingen',
  undo: 'Angre',
  redo: 'Gjer om',
  removedDays: { one: 'Fjerna 1 dag', other: 'Fjerna {n} dagar' },
  timesCleared: 'Tidene er fjerna',
  weekdays: 'Kvardagar',
  weekends: 'Helger',
  holidays: 'Heilagdagar',
  weekdaysHint: 'Fjern dei valde kvardagane (måndag–fredag), eller vel alle i kalenderen',
  weekendsHint: 'Fjern dei valde laurdagane og søndagane, eller vel alle i kalenderen',
  holidaysHint: 'Fjern dei valde heilagdagane, eller vel alle heilagdagane i kalenderen',
  weekdayHint: 'Fjern dei valde {day}ane, eller vel alle i kalenderen',
  toggleWeek: 'Vel eller fjern veke {n}',
  weekShort: 'V',
  nDays: { one: '1 dag vald', other: '{n} dagar valde' },
  nSlots: { one: '1 tidsrute', other: '{n} tidsruter' },
  nDaysNoTimes: { one: '1 dag utan tider', other: '{n} dagar utan tider' },
  possibleTimes: 'Moglege tider',
  possibleTimesHint: 'Dra over rutene for å markere eller fjerne tider. Trykk på ein dag øvst for fleire val.',
  possibleTimesHintTouch: 'Trykk på ei rute for å markere eller fjerne henne, eller hald fingeren på ei rute og dra over fleire. Trykk på ein dag øvst for fleire val.',
  'preset.all': 'Heile dagen',
  'preset.work': 'Arbeidstid 9–17',
  'preset.evening': 'Kveld 17–22',
  'preset.clear': 'Ingen tider',
  pickDaysFirst: 'Vel dagar i kalenderen først.',
  dayAll: 'Vel heile dagen',
  dayClear: 'Fjern alle tider denne dagen',
  dayCopy: 'Bruk desse tidene på alle dagar',
  dayCopyHint: 'Dagar du legg til seinare, får òg desse tidene',
  dayRemove: 'Fjern dagen',
  settings: 'Innstillingar',
  'set.maybe': 'Tillat «kanskje»',
  'set.maybeHint': 'Deltakarane kan svare «kan om det må til».',
  'set.maybeCounts': '«Kanskje» tel som at dei kan',
  'set.maybeCountsHint': 'Rangeringa tel alle som kan eller kanskje kan. Elles tel berre ja, og ved likt tal på ja står den med flest «kanskje» først.',
  'set.openEdit': 'endre og slette svara til alle',
  'set.openEditHint': 'Elles berre sitt eige.',
  'set.hidden': 'sjå svara',
  'set.hiddenHint': 'Kven som har svart kva, og kor mange. Elles ser berre arrangørane det, og kvar deltakar sitt eige svar.',
  'set.closed': 'Stengd for nye svar',
  'set.closedHint': 'Ingen andre enn arrangørane kan svare eller endre noko.',
  'set.newNames': 'svare under eit nytt namn',
  'set.newNamesHint': 'Elles kan berre namna de har sett på lista, svare.',
  'set.claims': 'svare som eit namn på lista',
  'set.claimsHint': 'Ved å trykkje på namnet sitt med avrøystingslenkja. Elles treng dei den personlege lenkja si frå dykk.',
  'set.rename': 'endre namnet sitt',
  'set.renameHint': 'Elles står namnet slik det vart skrive først, eller slik de skreiv det på lista.',
  'set.decide': 'velje kva det blir',
  'set.decideHint': 'Velje den endelege dagen eller tida, og angre valet. Avrøystinga held fram med å vere open: berre arrangørane stengjer ho.',
  'set.details': 'endre namn, stad og skildring',
  'set.detailsHint': 'På avrøystinga. Det syner ikkje kven som endra dei, men de kan alltid endre dei tilbake.',
  yourEmailOptional: 'E-posten din (valfritt)',
  adminEmailsOptional: 'E-post til arrangørane (valfritt)',
  addDetails: 'Legg til skildring og stad',
  manyWeeks: 'Deltakarane må gå gjennom {n} veker med tider, éi veke om gongen på mobil. Færre dagar gjer det raskare å svare.',
  emailOptional: 'E-post (valfritt)',
  addEmail: 'Legg til e-post',
  adminEmailHint: 'Blir lagra med avrøystinga, så du kan finne avrøystinga att på ei anna eining (vi sender deg ein kode). Er de fleire arrangørar, kan de leggje inn ein e-post kvar. Berre dei med admin-lenkja ser dei.',
  addEmailRow: 'Legg til ein e-post til',
  removeEmail: 'Fjern e-posten',
  createEvent: 'Lag avrøysting',
  saveChanges: 'Lagre endringar',
  lostAnswers: {
    one: '1 svar gjeld dagar eller tider som du fjernar, og blir sletta.',
    other: '{n} svar gjeld dagar eller tider som du fjernar, og blir sletta.',
  },
  saveAnyway: 'Lagre likevel',

  createdTitle: 'Avrøystinga er klar!',
  createdText: 'Del avrøystingslenkja med dei du vil invitere. Ta vare på admin-lenkja: med henne endrar du avrøystinga, og du kan dele henne med andre arrangørar.',
  savedNewTitle: 'Takk, {name}! Svara er lagra.',
  savedNewText: 'Dette er den personlege lenkja di. Med henne kan du endre svara seinare, frå kva eining som helst.',
  savedNewHint: 'Ta vare på lenkja: legg henne til som bokmerke eller send henne til deg sjølv. Ikkje del henne – den som har lenkja, kan endre svara dine.',
  yourLink: 'Den personlege lenkja di',
  linkInvalid: 'Denne lenkja verkar ikkje lenger. Ho kan vere bytt ut med ei ny, eller svaret er sletta. Du ser avrøystinga som gjest.',
  storedAdmin: 'Du er admin for denne avrøystinga på denne eininga.',
  storedMine: 'Denne eininga har den personlege lenkja di til denne avrøystinga.',
  closedInfo: 'Avrøystinga er stengd for nye svar.',
  closedAdmin: 'Avrøystinga er stengd. Berre arrangørane kan leggje til eller endre svar.',
  metaDates: { one: '1 mogleg dag', other: '{n} moglege dagar' },
  metaTimes: 'Klokkeslett · møtet varer {dur}',
  timesIn: 'Tider i {tz}',
  yourTz: '(du er i {tz})',
  metaHidden: 'Berre arrangørane ser svara',
  metaOpenEdit: 'Alle kan endre svara',
  permsTitle: 'Deltakarane kan',
  metaListOnly: 'Berre namna på lista kan svare',
  metaDecide: 'Alle kan velje kva det blir',
  editDetails: 'Endre namn og stad',
  editDetailsHint: 'Alle med avrøystingslenkja ser endringa.',
  detailsSaved: 'Endringane er lagra.',
  listOnlyInfo: 'Berre dei på lista kan svare, med den personlege lenkja dei har fått frå arrangørane.',
  listOnlyClaim: 'Berre namna på lista kan svare.',
  nameFixed: 'Namnet kan ikkje endrast i denne avrøystinga.',
  youAreAdmin: 'Du er admin',
  adminHint: 'Du kan endre avrøystinga og alle svara.',
  addAnswers: 'Legg til svar',
  personName: 'Namn',
  close: 'Steng',
  reopen: 'Opna igjen',
  hiName: 'Hei, {name}!',
  personalHint: 'Dette er den personlege lenkja di. Bruk henne når du vil endre svara.',
  editYourAnswers: 'Endre svara dine',
  copyMyLink: 'Kopier lenkja mi',
  shareEvent: 'Del avrøystinga',
  addYourAnswers: 'Legg til svara dine',
  shareTitle: 'Del avrøystinga',
  shareHint: 'Send denne lenkja til alle som skal vere med.',
  eventLink: 'Avrøystingslenkje',
  adminLinkTitle: 'Admin-lenkja',
  adminLinkHint: 'Del henne med dei som skal vere arrangørar saman med deg. Alle som har henne, kan endre avrøystinga og alle svara.',
  qrTitle: 'QR-kode for avrøystinga',
  resultsTitle: 'Kva passar best?',
  noAnswersYet: 'Ingen har svart enno.',
  noneAvailable: 'Ingen av alternativa passar for nokon enno.',
  hiddenInfo: 'Svara er skjulte: berre arrangørane ser dei, og kor mange som har svart.',
  'tab.cal': 'Kalender',
  'tab.list': 'Liste',
  'tab.table': 'Tabell',
  'tab.grid': 'Rutenett',
  legendFew: 'Få kan',
  legendMany: 'Mange kan',
  legendTop: 'Flest kan',
  tapForDetails: 'Trykk på eit alternativ for å sjå kven som kan.',
  tapCellForDetails: 'Trykk på ei rute for å sjå kven som kan.',
  nOfM: '{n} av {m} kan',
  decidedTitle: 'Avtalt',
  decidedTag: 'Valt',
  decidedThis: 'Dette er valt',
  decideThis: 'Vel {when}',
  decideQ: 'Velje {when}? Alle som opnar avrøystinga, ser valet, og avrøystinga blir stengd for nye svar.',
  decideOk: 'Vel',
  decidedToast: 'Valt. Del lenkja, så ser alle det.',
  undecideQ: 'Angre valet? Avrøystinga held fram med å vere stengd til du opnar ho igjen.',
  decideQOpen: 'Velje {when}? Alle som opnar avrøystinga, ser valet.',
  undecideQOpen: 'Angre valet?',
  undoDecision: 'Angre valet',
  undecidedToast: 'Valet er angra',
  addToCalendar: 'Legg i kalender',
  nMaybe: { one: '1 kanskje', other: '{n} kanskje' },
  nMaybeIncl: { one: 'inkl. 1 kanskje', other: 'inkl. {n} kanskje' },
  moreTied: { one: 'Vis 1 til med like mange som kan', other: 'Vis {n} til med like mange som kan' },
  showFewer: 'Vis færre',
  rankYesFirst: 'Rangert etter flest ja. Ved likt tal står den med flest «kanskje» først.',
  rankMaybeCounts: 'Rangert etter flest som kan, «kanskje» medrekna. Ved likt tal står den med flest ja først.',
  canCome: 'Kan',
  ifNeedBe: 'Kanskje',
  cannot: 'Kan ikkje',
  responses: 'Svar',
  hiddenPeople: 'Svara er skjulte. Du ser berre ditt eige.',
  sumYes: 'Kan {n} av {m}',
  sumYesTime: 'Kan {dur}',
  maybeDur: 'kanskje {dur}',
  sumNoneDates: 'Kan ingen av dagane',
  sumNoneTimes: 'Kan ingen av tidene',
  nOfTotal: '{n} av {m}',
  answeredOf: '{n} av {m} har svart',
  notAnswered: 'Har ikkje svart enno',
  noAnswer: 'Ikkje svart',
  youNotAnswered: 'Du har ikkje svart enno.',
  addNames: 'Legg til namn',
  addNamesTitle: 'Kven er invitert?',
  addNamesText: 'Eitt namn per linje, eller lim inn ei liste. Då ser du kven som ikkje har svart enno, og kvar får si eiga lenkje som du kan sende dei. Namna blir viste for alle som opnar avrøystinga, med mindre svara er skjulte.',
  addNamesPh: 'Kari\nOla\nPer',
  addNamesOk: 'Legg til',
  namesAdded: { one: 'La til 1 namn.', other: 'La til {n} namn.' },
  namesSkipped: { one: '1 namn var der frå før.', other: '{n} namn var der frå før.' },
  copyReminder: 'Kopier påminning',
  reminderText: '{names}: hugs å svare på «{name}»! {url}',
  claimQ: 'Er du ein av desse?',
  claimHint: 'Trykk på namnet ditt, så blir svara dine lagra der. Står du ikkje på lista, skriv du berre namnet ditt.',
  claimWho: 'Kven er du?',
  claimListHint: 'Berre namna på lista kan svare. Skriv for å finne ditt.',
  claimAdmin: 'Svarer du for ein av desse?',
  claimAdminHint: 'Trykk på eit namn for å leggje svara der, eller skriv eit nytt namn.',
  answerFor: 'Svar for {name}',
  removeName: 'Fjern {name}',
  removeNameQ: 'Fjerne {name} frå lista?',
  remove: 'Fjern',
  showAnswered: 'Vis som besvart',
  draftNoteOwn: 'Blir lagra som utkast: du står under «Har ikkje svart enno», og svara blir ikkje talde med før du lagrar med denne på.',
  draftNote: 'Blir lagra som utkast: personen står under «Har ikkje svart enno», og svara blir ikkje talde med før dei blir lagra med denne på.',
  draftSaved: 'Utkastet er lagra. Det blir ikkje tald med før det blir lagra som besvart.',
  savedDraftTitle: 'Utkastet ditt er lagra, {name}.',
  youHaveDraft: 'Du har eit utkast som ikkje blir tald med enno.',
  claimNone: 'Ingen på lista heiter det, så det blir eit nytt namn.',
  claimMatches: { one: '1 namn på lista passar', other: '{n} namn på lista passar' },
  showAllNames: 'Vis alle ({n})',
  answerAs: 'Svar som {name}',
  copyPersonLink: 'Lenkja til {name}',
  deleteEntry: 'Slett svaret til {name}',
  expiresNote: 'Avrøystinga blir sletta automatisk {date}.',
  adminMenu: 'Admin',
  newAdminLink: 'Ny admin-lenkje',
  newAdminLinkHint: 'Den gamle sluttar å verke',
  newAdminLinkQ: 'Lage ei ny admin-lenkje? Den gamle sluttar å verke med ein gong, for alle som har henne.',
  makeNewLink: 'Lag ny lenkje',
  newLinkDone: 'Ny lenkje',
  newAdminLinkDoneText: 'Dette er den nye admin-lenkja. Den gamle verkar ikkje lenger, så send denne til eventuelle andre arrangørar.',
  deleteEvent: 'Slett avrøystinga',
  deleteEventHint: 'Slettar alt, òg alle svara',
  deleteEventQ: 'Slette avrøystinga og alle svara? Det kan ikkje angrast.',
  eventDeleted: 'Avrøystinga er sletta',
  meMenu: 'Svara dine',
  newMyLink: 'Ny personleg lenkje',
  newMyLinkHint: 'Den gamle sluttar å verke',
  newMyLinkQ: 'Lage ei ny personleg lenkje? Den gamle sluttar å verke med ein gong.',
  newMyLinkDoneText: 'Dette er den nye personlege lenkja di. Den gamle verkar ikkje lenger.',
  deleteMine: 'Slett svara mine',
  deleteMineQ: 'Slette svara dine?',
  deleteEntryQ: 'Slette svaret til {name}?',
  personLinkTitle: 'Lenkja til {name}',
  personLinkText: 'Den som har denne lenkja, kan endre svara. Send henne berre til personen det gjeld.',
  addedByAdminText: 'Svaret er lagt til. Med denne lenkja kan personen endre svara sjølv seinare.',
  closedToast: 'Avrøystinga er stengd',
  reopenedToast: 'Avrøystinga er opna igjen',

  editAnswersOf: 'Endre svara til {name}',
  yourName: 'Namnet ditt',
  emailHint: 'Blir lagra med svaret, så du kan finne avrøystinga att på ei anna eining (vi sender deg ein kode). Ingen andre ser han.',
  commentOptional: 'Kommentar (valfritt)',
  commentPh: 'Til dømes «Kan berre etter kl. 18»',
  whichDays: 'Kva dagar passar?',
  whichTimes: 'Kva tider passar?',
  answerDatesHint: 'Trykk på dagane du kan.',
  answerDatesHintMaybe: 'Trykk éin gong for «ja», to gonger for «kanskje» og tre gonger for å fjerne.',
  answerTimesHint: 'Dra over tidene du kan. Dra frå ei markert rute for å fjerne. Trykk på ein dag øvst for å svare for heile dagen.',
  answerTimesHintMaybe: 'Vel «Kan» eller «Kanskje» og dra over tidene. Dra frå ei markert rute for å fjerne. Trykk på ein dag øvst for å svare for heile dagen.',
  answerTimesHintTouch: 'Trykk på tidene du kan, eller hald fingeren på ei rute og dra over fleire. Start på ei markert rute for å fjerne. Trykk på ein dag øvst for å svare for heile dagen.',
  answerTimesHintTouchMaybe: 'Vel «Kan» eller «Kanskje» og trykk på tidene, eller hald fingeren på ei rute og dra over fleire. Start på ei markert rute for å fjerne. Trykk på ein dag øvst for å svare for heile dagen.',
  brush: 'Marker som',
  yesToAll: 'Ja til alle',
  clearAll: 'Nullstill',
  dayYes: 'Kan heile dagen',
  dayMaybe: 'Kanskje heile dagen',
  dayNone: 'Kan ikkje denne dagen',
  pickSumDates: 'Du kan {n} av {m} dagar',
  pickSumTimes: 'Du kan {dur}',
  pickSumNone: 'Ingenting markert enno',
  discardQ: 'Forkaste endringane?',
  discard: 'Forkast',

  weeks: 'Veker',
  weekN: 'Veke {n}',
  weekRange: 'Veke {a}–{b}',
  weekPair: 'Veke {a} og {b}',
  gridPaintLabel: 'Tider. Piltastane flyttar, mellomrom markerer.',
  gridViewLabel: 'Oversikt over tidene',

  'err.network': 'Fekk ikkje kontakt med tenaren. Sjekk nettet og prøv igjen.',
  'err.rate': 'For mange førespurnader. Vent litt og prøv igjen.',
  'err.notFound': 'Fann ikkje avrøystinga.',
  'err.forbidden': 'Du har ikkje lov til å gjere dette.',
  'err.listOnly': 'Berre namna på lista kan svare. Vel ditt.',
  'err.rename': 'Namnet kan ikkje endrast i denne avrøystinga.',
  'err.decided': 'Det er ikkje eitt av alternativa.',
  'err.closed': 'Avrøystinga er stengd for nye svar.',
  'err.full': 'Avrøystinga har fått så mange svar som ho kan ta.',
  'err.person': 'Fann ikkje svaret. Det kan vere sletta.',
  'err.personName': 'Skriv inn namnet ditt.',
  'err.email': 'E-postadressa ser ikkje rett ut.',
  'err.emails': 'Høgst 10 e-postadresser.',
  'err.code': 'Koden er feil eller har gått ut.',
  'err.link': 'Lenkja er alt brukt eller har gått ut. Be om ein ny kode.',
  'err.wait.minute': 'Du bad nettopp om ein kode. Vent eit minutt før du ber om ein ny.',
  'err.wait.hour': 'Du har bede om fleire kodar. Prøv igjen om ein time.',
  'err.wait.day': 'Grensa for kodar i dag er nådd. Prøv igjen i morgon.',
  'err.mail': 'Vi kan ikkje sende e-post akkurat no. Prøv igjen seinare.',
  'err.name': 'Gi avrøystinga eit namn.',
  'err.range': 'Ugyldige datoar.',
  'err.rangeLong': 'Det kan vere høgst eitt år frå første til siste dag.',
  'err.rangeLongTimes': 'Med klokkeslett kan det vere høgst 62 dagar frå første til siste dag.',
  'err.hours': 'Vel eit gyldig tidsrom.',
  'err.options': 'Vel minst éin mogleg dag eller tid.',
  'err.tooMany': 'For mange moglege tider (høgst 2000). Vel færre dagar eller lengre ruter.',
  'err.server': 'Noko gjekk gale. Prøv igjen.',
  'err.taken': 'Nokon har nett svart under det namnet. Vel eit anna, eller skriv namnet ditt.',
  'err.answered': 'Personen har nett svart sjølv, så svara deira står som dei er.',
  'err.names': 'Skriv minst eitt namn.',
  'err.tooManyNames': 'Det blir for mange. Ei avrøysting kan ha høgst 200 namn og svar til saman.',

  'holiday.newYear': '1. nyttårsdag',
  'holiday.maundyThursday': 'Skjærtorsdag',
  'holiday.goodFriday': 'Langfredag',
  'holiday.easter': '1. påskedag',
  'holiday.easterMonday': '2. påskedag',
  'holiday.mayDay': 'Arbeidarane sin dag',
  'holiday.constitutionDay': 'Grunnlovsdagen',
  'holiday.ascension': 'Kristi himmelfartsdag',
  'holiday.whitsun': '1. pinsedag',
  'holiday.whitMonday': '2. pinsedag',
  'holiday.christmas': '1. juledag',
  'holiday.boxingDay': '2. juledag',
  'holiday.christmasEve': 'Julaftan',
  'holiday.newYearsEve': 'Nyttårsaftan',
  'holiday.epiphany': 'Heilage tre kongars dag',
  'holiday.nationalDaySe': 'Sveriges nasjonaldag',
  'holiday.midsummerEve': 'Midtsommaraftan',
  'holiday.midsummerDay': 'Midtsommardagen',
  'holiday.allSaints': 'Allehelgensdag',
  'holiday.greatPrayerDay': 'Store bededag',
  holidayCal: 'Heilagdagar i kalenderen',
  holidayCalHint: 'Heilagdagane får ein prikk, og knappen «Heilagdagar» vel dei. Julaftan og nyttårsaftan er med, i Sverige òg midtsommaraftan.',
  'holidayCal.no': 'Noreg',
  'holidayCal.se': 'Sverige',
  'holidayCal.dk': 'Danmark',
  'holidayCal.none': 'Ingen',
};
